<div
  class="accordion"
  [class.grid]="isOpen"
  [class.accordion-panel]="!isNested"
  [class.accordion-nested-panel]="isNested"
>
  @if (isNested) {
    <hr class="accordion__divide" />
  }

  <div
    class="accordion__header accordion__header--no-pointer flex"
    [class.accordion__header-nested]="isNested"
    [class.accordion__header--no-pointer]="!showChevron"
    (click)="toggleAccordion()"
  >
    <div class="accordion__header-title flex-grow">
      <ng-content select="[header]"></ng-content>
    </div>

    @if (isLoading) {
      <div>
        @if (showOldSpinner) {
          <lib-spinner></lib-spinner>
        } @else {
          <lib-spinner-v2></lib-spinner-v2>
        }
      </div>
    }
    @if (showChevron) {
      <div class="accordion__header-icon" [class.accordion__header-centered]="centeredIcon">
        <div [@rotatedState]="isOpen && !isLoading">
          <lib-chevron-icon
            class="icon-theme icon-xxs"
            [ngClass]="{ 'icon-blue icon-xxs': isSubAccordion }"
          ></lib-chevron-icon>
        </div>
      </div>
    }
  </div>

  @if (!isLoading) {
    <div class="accordion__body" [@accordionBody]="isOpen" [class.overflow]="isOpen">
      <div class="accordion__body-content" [class.accordion__body-content-nested]="isNested && !isSubAccordion">
        <ng-content select="[body]"></ng-content>
      </div>
    </div>
  }
  @if (!isLoading) {
    <div class="accordion__footer">
      <div class="accordion__footer-content">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  }
</div>
